export default __webpack_public_path__ + "static/media/hamburger.a100bcc0.svg";